// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__wiJtoMtFSr{flex:1;min-width:0}`, "",{"version":3,"sources":["webpack://./src/components/contact/addContactAttributesModal/components/contactAttributeFormField/contactAttributeFormField.module.scss"],"names":[],"mappings":"AAAA,qBACE,MAAA,CACA,WAAA","sourcesContent":[".wrapper {\n  flex: 1;\n  min-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__wiJtoMtFSr`
};
export default ___CSS_LOADER_EXPORT___;
